import * as React from 'react';
import PropTypes from 'prop-types';
import { Confirmation, Grid, Typography } from '@upperhand/playmaker';
import { useHistory } from 'react-router-dom';
import { logout } from 'utils/auth';

const LinkButton = ({ children, onClick }) => (
  <button className="LinkButton" onClick={onClick} type="button">
    {children}
  </button>
);

const LogoutConfirmation = ({ onConfirm, onCancel, open }) => (
  <Confirmation
    confirmButtonLabel="Logout"
    cancelButtonLabel="Cancel"
    hasCheckbox={false}
    open={open}
    onConfirm={onConfirm}
    onCancel={onCancel}
    title="Confirm Logout"
  >
    Are you sure you want to logout?
  </Confirmation>
);

const MainHeader = ({ backToLink, showBackLink, showLogout }) => {
  const [awaitingLogout, setAwaitingLogout] = React.useState(false);

  const history = useHistory();

  const initLogout = () => {
    setAwaitingLogout(true);
  };

  const confirmLogout = () => {
    logout();
    setAwaitingLogout(false);
    window.location.replace('/login');
  };

  const cancelLogout = () => {
    setAwaitingLogout(false);
  };

  const submitBack = () =>
    backToLink ? history.push(backToLink) : history.goBack();

  return (
    <header className="MainHeader">
      <div className="MainHeaderContainer">
        <Grid
          container
          justify="space-between"
          wrap="nowrap"
          alignItems="center"
        >
          <Grid item container alignItems="center" spacing={2}>
            <Grid item>
              {showBackLink && (
                <LinkButton onClick={submitBack}>
                  <Typography color="textPrimary" variant="h3">
                    {'< Back'}
                  </Typography>
                </LinkButton>
              )}
            </Grid>
          </Grid>
          <Grid item>
            {showLogout && (
              <LinkButton onClick={initLogout}>
                <Typography variant="h3" color="textPrimary">
                  Logout
                </Typography>
              </LinkButton>
            )}
          </Grid>
        </Grid>
      </div>
      <LogoutConfirmation
        open={awaitingLogout}
        onConfirm={confirmLogout}
        onCancel={cancelLogout}
      />
    </header>
  );
};

MainHeader.defaultProps = {
  backToLink: null,
  showBackLink: true,
  showLogout: true,
};

MainHeader.propTypes = {
  backToLink: PropTypes.string,
  showBackLink: PropTypes.bool,
  showLogout: PropTypes.bool,
};

export default MainHeader;
